import { Component } from '@angular/core';

@Component({
    selector: 'app-playlist',
    imports: [],
    templateUrl: './playlist.component.html',
    styleUrl: './playlist.component.scss',
})
export class PlaylistComponent {}
